import type { CoverageStatus } from './types'

export const MONTH_WIDTH = 20
export const ROW_HEIGHT = 44
export const BLOCK_HEIGHT = 30
export const LABEL_WIDTH = 140
export const MARGIN = { top: 30, right: 60, bottom: 20, left: LABEL_WIDTH }
export const MAX_VISIBLE_ACCOUNT_ROWS = 6

// Palette mirrors ReconciliationBadge so the chart and the statements table match.
// Tailwind classes drive the SVG, the matching hex drives the PNG export.
// member_activity deliberately sits outside the verdict palette: a member card is never reconciled
// on its own, so its cells must not read as a verdict color.
export const COVERAGE_FILL_CLASS: Record<CoverageStatus, string> = {
  reconciled: 'fill-emerald-500 hover:fill-emerald-600 cursor-pointer',
  needs_review: 'fill-amber-500 hover:fill-amber-600 cursor-pointer',
  unverifiable: 'fill-slate-400 hover:fill-slate-500 cursor-pointer',
  not_checked: 'fill-blue-500 hover:fill-blue-600 cursor-pointer',
  member_activity: 'fill-violet-300 hover:fill-violet-400 cursor-pointer',
  verified_gap:
    'fill-emerald-100 hover:fill-emerald-200 stroke-emerald-400 stroke-[1px]',
  missing:
    'fill-neutral-200 hover:fill-neutral-300 stroke-neutral-400 stroke-[1px]',
}

export const COVERAGE_FILL_HEX: Record<CoverageStatus, string> = {
  reconciled: '#10b981',
  needs_review: '#f59e0b',
  unverifiable: '#94a3b8',
  not_checked: '#3b82f6',
  member_activity: '#c4b5fd',
  verified_gap: '#d1fae5',
  missing: '#e5e5e5',
}

export const COVERAGE_STATUS_LABEL: Record<CoverageStatus, string> = {
  reconciled: 'Reconciled',
  needs_review: 'Needs review',
  unverifiable: 'Unverifiable',
  not_checked: 'Covered (not checked)',
  member_activity: 'Member activity (reconciled under the primary account)',
  verified_gap: 'No statement issued (balances chain, nothing missing)',
  missing: 'No statement (potentially missing)',
}

// The same cells for an account without the reconciliation feature. Nothing checked its balances, so
// nothing here may hint at a verdict. The verdict states are unreachable for it, but they still need
// a label so the map stays total.
export const PLAIN_STATUS_LABEL: Record<CoverageStatus, string> = {
  reconciled: 'Covered',
  needs_review: 'Covered',
  unverifiable: 'Covered',
  not_checked: 'Covered',
  member_activity: 'Member activity',
  verified_gap: 'No statement issued',
  missing: 'No statement (potentially missing)',
}
